<template>
  <section>
    <div class="container">
      <div class="is-col-12-md">
        <h1>FORGOT PASSWORD</h1>
        <p>
          It&rsquo;s okay to forget things sometimes—except for proper sun protection. Please enter your email address
          to recover your password. </p>
      </div>
      <div class="is-col-12-md">
        <form id="forgotPasswordForm" @submit.prevent="sendFormData()">
          <div class="form-row-1">
            <div class="form-field">
              <label>Email address</label> <input class="input-field" type="email" v-model="email"
                                                  :class="{ invalid: errors.email }" @input="clear_error('email')"/>
              <p class="errorMsg-text" v-if="errors.email" v-html="errors.email[0]"></p>
            </div>
          </div>
          <button>
            RECOVER MY PASSWORD <i class="fas fa-caret-right"></i>
          </button>
          <div class="loader-container" v-show="showLoader">
            <img src="@/assets/images/global/loader.gif" alt=""/>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      errors: [],
      email: '',
      showLoader: false
    }
  },
  props: {
    initEmail: ''
  },
  mounted () {
    this.email =
      (this.initEmail && this.initEmail.length > 0)
        ? this.initEmail
        : this.$store.state.emailAddress
  },
  created () {},
  methods: {
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') { delete this.errors[field] }
    },
    sendFormData () {
      const _this = this
      _this.showLoader = true
      _this.axios.post(_this.$apiUrl + 'v1/password/reset-request', {
        email: _this.email
      }).then(function (response) {
        _this.showResponse = true
        if (response.data.errors.length === 0) {
          _this.$router.push({ name: 'ForgotPasswordThanks' }).catch(() => {})
        } else {
          _this.errors = response.data.errors
        }
        _this.showLoader = false
        _this.showResponse = true
      }).catch(function (error) {
        _this.showLoader = false
        _this.errors = error.response.data.errors
        setTimeout(() => {
          document.querySelector('input.invalid,select.invalid').focus()
        }, 200)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  text-align: left;
  margin-top: 65px;
  text-transform: uppercase;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    text-align: center;
    font-size: 45px;
    margin-top: 10px;
  }
}

.container {
  @media (min-width: 1025px) {
    // padding-left: 0;
  }
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 2rem;
    top: 90px;
    min-height: 88vh;
  }
}

.input-field {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  color: @color-txt-blue;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }
}

form {
  margin-top: 40px;

  button {
    margin-top: 40px;
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;

    span {
      margin-left: 10px;
    }

    @media screen and (max-width: 1000px) {
      width: 226px;
      font-size: 15px;
    }

    .fa-caret-right {
      margin-left: 7px;
      @media screen and (max-width: 1000px) {
        margin-left: 3px;
      }
    }
  }
}

.loader-container {
  display: inline-block;
  position: relative;
  margin-left: 2rem;
  top: 1rem;
}
</style>
